import React from "react";
import { MDBTable, MDBTableHead, MDBTableBody } from "mdbreact";
import "./DataTable.css";
import DataPaidInvoice from "../../pages/Invoice/Components/DataPaidInvoice";
import DataPendingInvoice from "../../pages/Invoice/Components/DataPendingInvoice";
import DataSummaryInvoice from "../../pages/Invoice/Components/DataSummaryInvoice";
import DataWaitingInvoice from "../../pages/Invoice/Components/DataWaitingInvoice";

const defaultHeaders = (active) => [
  {
    label: (
      <>
        <div>Invoice Number</div>
        <div>Placing Slip Number</div>
        <div>Policy Number</div>
        <div>Reference Number</div>
      </>
    ),
    style: { minWidth: 210 },
  },
  { label: "Product Code" },
  {
    label: (
      <>
        Company Name <br />
        Insured <br />
        Insurer
      </>
    ),
    style: { minWidth: 250 },
  },
  {
    label: (
      <>
        Policy Issue Date <br />
        Invoice Issue Date <br />
        Schedule Payment Date <br />
        Payment Date
      </>
    ),
    style: { minWidth: 210 },
  },
  {
    label: (
      <>
        Sum Insured <br />
        Premium
      </>
    ),
    style: { minWidth: 140 },
  },
  ...(active !== "summary" ? [{ label: "Action" }] : []),
];

export default function DataTable({
  invoices,
  active,
  onChecked,
  onBundleClick,
  headers,
}) {
  const tableHeaders = headers || defaultHeaders(active);

  const renderRow = (row, index) => {
    switch (active) {
      case "pending":
        return (
          <DataPendingInvoice
            key={row.id}
            row={row}
            onBundleClick={onBundleClick}
          />
        );
      case "summary":
        return <DataSummaryInvoice key={row.id} row={row} index={index} />;
      case "waiting":
        return (
          <DataWaitingInvoice
            key={row.id}
            row={row}
            index={index}
            onChecked={onChecked}
          />
        );
      case "paid":
      default:
        return <DataPaidInvoice key={row.id} row={row} index={index} />;
    }
  };

  return (
    <MDBTable hover responsive>
      <MDBTableHead>
        <tr>
          {tableHeaders.map((header, index) => {
            const { label, style } =
              typeof header === "string" ? { label: header } : header;

            return (
              <th key={`${label || "header"}-${index}`} style={style}>
                {label}
              </th>
            );
          })}
        </tr>
      </MDBTableHead>
      <MDBTableBody>{invoices.map(renderRow)}</MDBTableBody>
    </MDBTable>
  );
}
